/* Cards Game Night — slide-out cart drawer + sticky add-to-cart upgrades.
   Opens whenever something is added to the cart (any /cart/add request on the site),
   or when the header cart icon is clicked. Loaded globally from sections/cgn-skin.liquid. */
(function () {
  if (window.CGNCart) return;
  var CFG = window.CGN_CART || {};
  var ROOT = CFG.root || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var state = { cart: null, busy: false, recs: {} };

  /* ---------- helpers ---------- */
  function money(cents) {
    var fmt = CFG.money || '${{amount}}';
    var n = (cents || 0) / 100;
    var withCommas = function (v, d) { return v.toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return withCommas(Math.round(n), 0);
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return String(Math.round(n));
      return withCommas(n, 2);
    }).replace(/<[^>]*>/g, '');
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200);
  }
  function shortTitle(t) { return String(t || '').split(' - ')[0].split(' – ')[0]; }
  function json(url, opts) {
    return fetch(url, opts).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* ---------- markup ---------- */
  var el = document.createElement('div');
  el.className = 'cgn-drawer';
  el.setAttribute('aria-hidden', 'true');
  el.innerHTML =
    '<div class="cgn-drawer__overlay" data-close></div>' +
    '<aside class="cgn-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="cgn-drawer-title" tabindex="-1">' +
      '<header class="cgn-drawer__head">' +
        '<p class="cgn-drawer__title" id="cgn-drawer-title">Your stash <span data-count></span></p>' +
        '<button type="button" class="cgn-drawer__x" data-close aria-label="Close cart">' +
          '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
      '</header>' +
      '<div class="cgn-drawer__added" data-added hidden></div>' +
      '<div class="cgn-drawer__body" data-body></div>' +
      '<footer class="cgn-drawer__foot" data-foot></footer>' +
    '</aside>';
  document.body.appendChild(el);
  document.documentElement.classList.add('cgn-has-drawer');

  var panel = el.querySelector('.cgn-drawer__panel');
  var body = el.querySelector('[data-body]');
  var foot = el.querySelector('[data-foot]');
  var addedEl = el.querySelector('[data-added]');
  var countEl = el.querySelector('[data-count]');
  var lastFocus = null;

  /* ---------- render ---------- */
  function render() {
    var cart = state.cart;
    if (!cart) return;
    countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (!cart.item_count) {
      body.innerHTML =
        '<div class="cgn-drawer__empty">' +
          '<div class="cgn-drawer__empty-cards" aria-hidden="true"><span class="cgn-mini cgn-mini--b">My cart is empty because ___.</span><span class="cgn-mini cgn-mini--w">Commitment issues.</span></div>' +
          '<p class="cgn-drawer__empty-title">Your cart is emptier than your group chat.</p>' +
          '<a class="cgn-btn" href="' + esc(CFG.shopUrl || (ROOT + 'collections/cards')) + '">Shop the games</a>' +
        '</div>';
      foot.innerHTML = '';
      return;
    }
    var html = '<ul class="cgn-drawer__items">';
    cart.items.forEach(function (it, i) {
      var line = i + 1;
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      var disc = it.original_line_price > it.final_line_price;
      html +=
        '<li class="cgn-drawer__item" style="--i:' + i + '">' +
          '<a class="cgn-drawer__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 180)) + '" alt="' + esc(it.product_title) + '" loading="lazy" width="90" height="90">' : '') + '</a>' +
          '<div class="cgn-drawer__info">' +
            '<a class="cgn-drawer__name" href="' + esc(it.url) + '">' + esc(shortTitle(it.product_title)) + '</a>' +
            (variant ? '<p class="cgn-drawer__variant">' + esc(variant) + '</p>' : '') +
            (it.line_level_discount_allocations || []).map(function (d) {
              return '<p class="cgn-drawer__disc">' + esc(d.discount_application && d.discount_application.title || 'Discount') + ' (−' + money(d.amount) + ')</p>';
            }).join('') +
            '<div class="cgn-drawer__row">' +
              '<div class="cgn-drawer__qty" role="group" aria-label="Quantity">' +
                '<button type="button" data-qty="' + line + '" data-to="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
                '<span aria-live="polite">' + it.quantity + '</span>' +
                '<button type="button" data-qty="' + line + '" data-to="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<p class="cgn-drawer__price">' + (disc ? '<s>' + money(it.original_line_price) + '</s>' : '') + '<b>' + money(it.final_line_price) + '</b></p>' +
            '</div>' +
            '<button type="button" class="cgn-drawer__rm" data-qty="' + line + '" data-to="0">Remove</button>' +
          '</div>' +
        '</li>';
    });
    html += '</ul><div class="cgn-drawer__recs" data-recs></div>';
    body.innerHTML = html;

    var savings = cart.total_discount || 0;
    var cartDiscs = (cart.cart_level_discount_applications || []).map(function (d) {
      return '<p class="cgn-drawer__line cgn-drawer__line--disc"><span>' + esc(d.title) + '</span><span>−' + money(d.total_allocated_amount) + '</span></p>';
    }).join('');
    foot.innerHTML =
      cartDiscs +
      (savings > 0 ? '<p class="cgn-drawer__saved">You\'re saving ' + money(savings) + ' 🎉</p>' : '') +
      '<p class="cgn-drawer__line cgn-drawer__line--total"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></p>' +
      '<p class="cgn-drawer__fine">Taxes and shipping calculated at checkout.</p>' +
      '<a class="cgn-btn cgn-drawer__checkout" href="' + esc(ROOT + 'checkout') + '">Check out · ' + money(cart.total_price) + '</a>' +
      '<a class="cgn-drawer__view" href="' + esc(CFG.cartUrl || (ROOT + 'cart')) + '">View full cart</a>';
    loadRecs();
  }

  /* ---------- recommendations: "Add another deck" ---------- */
  function loadRecs() {
    var box = body.querySelector('[data-recs]');
    var cart = state.cart;
    if (!box || !cart || !cart.items.length) return;
    var pid = cart.items[0].product_id;
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var draw = function (list) {
      list = (list || []).filter(function (p) { return p.available && inCart.indexOf(p.id) === -1; }).slice(0, 3);
      if (!list.length) { box.innerHTML = ''; return; }
      box.innerHTML = '<p class="cgn-drawer__recs-title">Add another deck</p><div class="cgn-drawer__recs-list">' +
        list.map(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
          var src = p.featured_image || (p.images && p.images[0]) || '';
          if (src && src.indexOf('//') === 0) src = 'https:' + src;
          return '<div class="cgn-drawer__rec">' +
            '<a href="' + esc(p.url) + '" class="cgn-drawer__rec-img">' + (src ? '<img src="' + esc(img(src, 160)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
            '<p class="cgn-drawer__rec-name">' + esc(shortTitle(p.title)) + '</p>' +
            '<p class="cgn-drawer__rec-price">' + money(v.price) + '</p>' +
            '<button type="button" class="cgn-drawer__rec-add" data-rec-add="' + v.id + '">+ Add</button>' +
          '</div>';
        }).join('') + '</div>';
    };
    if (state.recs[pid]) return draw(state.recs[pid]);
    json(ROOT + 'recommendations/products.json?product_id=' + pid + '&limit=6&intent=related')
      .then(function (r) { state.recs[pid] = r.products || []; draw(state.recs[pid]); })
      .catch(function () { box.innerHTML = ''; });
  }

  /* ---------- cart ops ---------- */
  function refreshBubble() {
    return fetch(ROOT + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var html = s && s['cart-icon-bubble'];
      var target = document.getElementById('cart-icon-bubble');
      if (!html || !target) return;
      var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (inner) target.innerHTML = inner.innerHTML;
    }).catch(function () {});
  }
  function load() {
    return json(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (c) { state.cart = c; render(); return c; });
  }
  function change(line, qty) {
    if (state.busy) return;
    state.busy = true;
    el.classList.add('is-busy');
    json(ROOT + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
    }).then(function (c) { state.cart = c; render(); refreshBubble(); })
      .catch(function (e) { flashMsg((e && (e.description || e.message)) || 'Could not update the cart.'); })
      .then(function () { state.busy = false; el.classList.remove('is-busy'); });
  }
  function addVariant(id, btn) {
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    json(ROOT + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function () { return added(); })
      .catch(function (e) { flashMsg((e && e.description) || 'Could not add that item.'); if (btn) { btn.disabled = false; btn.textContent = '+ Add'; } });
  }
  var msgTimer;
  function flashMsg(text, good) {
    addedEl.innerHTML = (good ? '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 7"/></svg>' : '') + '<span>' + esc(text) + '</span>';
    addedEl.classList.toggle('is-bad', !good);
    addedEl.hidden = false;
    clearTimeout(msgTimer);
    msgTimer = setTimeout(function () { addedEl.hidden = true; }, 3500);
  }
  function added() {
    return load().then(function () {
      refreshBubble();
      flashMsg('Added to your cart. Bad decisions confirmed.', true);
      open();
    });
  }

  /* ---------- open / close ---------- */
  function open() {
    if (el.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cgn-drawer-lock');
    setTimeout(function () { panel.focus({ preventScroll: true }); }, reduce ? 0 : 80);
  }
  function close() {
    if (!el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cgn-drawer-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  el.addEventListener('click', function (e) {
    if (e.target.closest('[data-close]')) { close(); return; }
    var q = e.target.closest('[data-qty]');
    if (q) { change(parseInt(q.dataset.qty, 10), parseInt(q.dataset.to, 10)); return; }
    var r = e.target.closest('[data-rec-add]');
    if (r) addVariant(parseInt(r.dataset.recAdd, 10), r);
  });
  document.addEventListener('keydown', function (e) {
    if (!el.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('a[href],button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- open on every successful add-to-cart (fetch) ---------- */
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) { if (res && res.ok) setTimeout(added, reduce ? 0 : 450); }).catch(function () {});
    }
    return p;
  };

  /* ---------- plain add-to-cart forms (home grid, collection cards, quick add) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || !/\/cart\/add/.test(form.action)) return;
    if (form.matches('.cgn-pdp__form') || form.closest('product-form') || e.defaultPrevented) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Adding…'; }
    origFetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return added(); })
      .catch(function (err) { load().then(open); flashMsg((err && err.description) || 'Could not add that item.'); })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.innerHTML = label; } });
  });

  /* ---------- header cart icon opens the drawer ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('#cart-icon-bubble, a[href$="/cart"].header__icon--cart');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    load().then(open);
  });

  /* ---------- sticky add-to-cart: product image + option picker ---------- */
  function upgradeSticky() {
    var sticky = document.querySelector('[data-sticky]');
    var pdp = document.querySelector('[data-cgn-pdp]');
    if (!sticky || !pdp || sticky.dataset.upgraded) return;
    sticky.dataset.upgraded = '1';
    var product;
    try { product = JSON.parse(pdp.querySelector('[data-cgn-product]').textContent); } catch (err) { return; }
    var inner = sticky.querySelector('.cgn-sticky__inner');
    var btn = sticky.querySelector('[data-sticky-btn]');
    if (!inner || !btn) return;
    if (product.variants.length > 1 && product.options.length === 1) {
      // Custom picker (not a native <select>) so the list opens the same way on iPhone,
      // Android and desktop: a small menu that pops up directly above the sticky bar.
      var optName = product.options[0].name || product.options[0];
      var wrap = document.createElement('div');
      wrap.className = 'cgn-sticky__pick';
      var tgl = document.createElement('button');
      tgl.type = 'button';
      tgl.className = 'cgn-sticky__select';
      tgl.setAttribute('aria-haspopup', 'listbox');
      tgl.setAttribute('aria-expanded', 'false');
      tgl.innerHTML = '<span data-pick-label></span><svg viewBox="0 0 12 8" width="12" height="8" aria-hidden="true"><path d="M1 7l5-5 5 5" stroke="currentColor" stroke-width="2" fill="none"/></svg>';
      var menu = document.createElement('ul');
      menu.className = 'cgn-sticky__menu';
      menu.setAttribute('role', 'listbox');
      menu.setAttribute('aria-label', optName);
      menu.hidden = true;
      product.variants.forEach(function (v) {
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.dataset.value = v.options[0];
        li.tabIndex = -1;
        li.innerHTML = '<span></span><b></b>';
        li.querySelector('span').textContent = v.options[0];
        li.querySelector('b').textContent = v.available ? money(v.price) : 'Sold out';
        if (!v.available) li.setAttribute('aria-disabled', 'true');
        menu.appendChild(li);
      });
      wrap.appendChild(menu);
      wrap.appendChild(tgl);
      var label = tgl.querySelector('[data-pick-label]');
      var sync = function () {
        var c = pdp.querySelector('[data-opt="0"]:checked');
        var val = c ? c.value : product.variants[0].options[0];
        label.textContent = val;
        menu.querySelectorAll('li').forEach(function (li) { li.setAttribute('aria-selected', li.dataset.value === val ? 'true' : 'false'); });
      };
      var closeMenu = function (focus) {
        menu.hidden = true; tgl.setAttribute('aria-expanded', 'false'); wrap.classList.remove('is-open');
        if (focus) tgl.focus();
      };
      var openMenu = function () {
        menu.hidden = false; tgl.setAttribute('aria-expanded', 'true'); wrap.classList.add('is-open');
        var cur = menu.querySelector('[aria-selected="true"]') || menu.querySelector('li');
        if (cur) cur.focus({ preventScroll: true });
      };
      var choose = function (li) {
        if (!li || li.getAttribute('aria-disabled') === 'true') return;
        pdp.querySelectorAll('[data-opt="0"]').forEach(function (r) {
          if (r.value === li.dataset.value) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
        });
        sync(); closeMenu(true);
      };
      tgl.addEventListener('click', function (e) { e.stopPropagation(); if (menu.hidden) openMenu(); else closeMenu(); });
      menu.addEventListener('click', function (e) { e.stopPropagation(); choose(e.target.closest('li')); });
      menu.addEventListener('keydown', function (e) {
        var items = Array.prototype.slice.call(menu.querySelectorAll('li'));
        var i = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(document.activeElement); }
        else if (e.key === 'Escape' || e.key === 'Tab') { closeMenu(e.key === 'Escape'); }
      });
      document.addEventListener('click', function (e) { if (!menu.hidden && !wrap.contains(e.target)) closeMenu(); });
      window.addEventListener('scroll', function () { if (!menu.hidden && !sticky.classList.contains('is-on')) closeMenu(); }, { passive: true });
      sync();
      pdp.addEventListener('change', function (e) { if (e.target.matches('[data-opt]')) sync(); });
      inner.insertBefore(wrap, btn);
    }
    // Show the bar a little earlier on phones: as soon as the main button leaves the screen
    btn.classList.add('cgn-sticky__btn');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', upgradeSticky); else upgradeSticky();
  document.addEventListener('shopify:section:load', upgradeSticky);

  window.CGNCart = { open: function () { load().then(open); }, close: close, refresh: load };
})();
